import React from 'react';
import { MenuItem, Menu, Button, Popover } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { FilterWrapper } from 'components/styled-components';
import isEqual from 'lodash/isEqual';
import shortid from 'shortid';

const RenderedFilters = ({ handleChangeFilter, active, filter }) => {
  return (
    <MenuItem
      onClick={() => handleChangeFilter(filter)}
      text={filter.label}
      key={shortid.generate()}
      active={isEqual(filter, active)}
    />
  );
};

const FilterMenuDropDown = props => {
  return (
    <Menu>
      {props.statusFilters.map(status => (
        <RenderedFilters filter={status} {...props} key={shortid.generate()} />
      ))}
    </Menu>
  );
};

const FilterMenu = ({ handleChangeFilter, selectedFilter, statusFilters }) => (
  <Popover
    content={
      <FilterMenuDropDown
        handleChangeFilter={handleChangeFilter}
        active={selectedFilter}
        statusFilters={statusFilters}
      />
    }
    autoFocus={false}
  >
    <FilterWrapper>
      <Button
        icon={IconNames.FILTER_LIST}
        rightIcon={IconNames.CARET_DOWN}
        text={`Status Filter: ${selectedFilter.label}`}
        className={`${
          selectedFilter.label === '' ? 'light-blue' : 'filter-selected'
        }`}
        fill
        alignText="left"
        style={{ whiteSpace: 'nowrap' }}
      />
    </FilterWrapper>
  </Popover>
);

export default FilterMenu;
